var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"mt-2 mb-2 dotted-line tm15"}),_vm._v(" "),_c('div',{staticClass:"d-flex bm15"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"mr-auto section-title"},[_vm._v(_vm._s(_vm.text)),_c('span',{staticClass:"section-value"},[_vm._v(_vm._s(_vm.value))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d42a71","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DottedLineHeader.vue
// module id = null
// module chunks = 